import { API_URL, fetchWithHandling } from './api';

// ---------------------------------------------------------------------------
// Memory API Functions
//
// What the assistant remembers across chats: the project's shared tool
// facts (e.g. a colleague's Jira account ID) plus this person's own
// preferences, people, context and notes, and how the mailbox writes. Written by the backend;
// the Memory settings tab lists, edits and deletes. Same auth shape as
// skillsApi.js; responses are the AppResponse envelope.
// ---------------------------------------------------------------------------

export async function listMemories(accessToken) {
  return fetchWithHandling(`${API_URL}/data/memory/list`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export async function deleteMemory(accessToken, memoryId) {
  return fetchWithHandling(
    `${API_URL}/data/memory/${encodeURIComponent(memoryId)}`,
    {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${accessToken}` },
    },
  );
}

/**
 * Edit a memory. Omit a field to leave it; expiresOn is 'YYYY-MM-DD'
 * (temporary facts), clearExpiry removes the end date.
 */
export async function updateMemory(
  accessToken,
  memoryId,
  { value, expiresOn, clearExpiry = false } = {},
) {
  const body = { clear_expiry: clearExpiry };
  if (value !== undefined) body.value = value;
  if (expiresOn) body.expires_on = expiresOn;
  return fetchWithHandling(
    `${API_URL}/data/memory/${encodeURIComponent(memoryId)}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(body),
    },
  );
}
